/* ==========================================================================
   opora-home-anim.js
   Homepage animations — scroll reveals, H1 word stagger, magnetic buttons,
   counter animations.
   Ported from proto_review_v2/motion.js sections 2, 3, 4, 5.
   Only loaded on index (home) template via layout/theme.liquid gate.
   Respects prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── SF-7: Hero H1 staggered word reveal ──────────────────────────────── */
  /* Splits #heroH1 text into .word spans at runtime and staggers their
     fade-in animation. Keeps the Liquid markup clean. */
  var h1 = document.getElementById('heroH1');
  if (h1) {
    if (REDUCED) {
      // Reduced motion: show immediately, no animation
      h1.style.opacity = '1';
    } else {
      // Split text content into word spans (runtime, no markup change needed)
      var rawHTML = h1.innerHTML;
      // If no .word spans exist yet, create them from text nodes
      var hasWordSpans = h1.querySelector('.word');
      if (!hasWordSpans) {
        // Walk text nodes and wrap each whitespace-separated word
        function wrapWords(node) {
          if (node.nodeType === Node.TEXT_NODE) {
            var parts = node.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function (part) {
              if (/^\s+$/.test(part) || part === '') {
                frag.appendChild(document.createTextNode(part));
              } else {
                var span = document.createElement('span');
                span.className = 'word';
                span.textContent = part;
                frag.appendChild(span);
              }
            });
            node.parentNode.replaceChild(frag, node);
          } else if (node.nodeType === Node.ELEMENT_NODE &&
                     node.tagName !== 'SPAN' ||
                     (node.className && node.className.indexOf('word') === -1)) {
            // Recurse into child elements (e.g. <span class="ohv3-hero__ai">)
            Array.from(node.childNodes).forEach(wrapWords);
          }
        }
        // Only wrap direct text — don't destroy existing markup
        Array.from(h1.childNodes).forEach(function (child) {
          if (child.nodeType === Node.TEXT_NODE) {
            wrapWords(child);
          }
        });
      }
      // Stagger the .word animations
      h1.querySelectorAll('.word').forEach(function (w, i) {
        w.style.animationDelay = (100 + i * 70) + 'ms';
        w.style.opacity = '0';
        w.style.transform = 'translateY(28px)';
        w.style.display = 'inline-block';
        w.style.transition = 'opacity 0.85s cubic-bezier(0.16,1,0.3,1) ' + (100 + i * 70) + 'ms, transform 0.85s cubic-bezier(0.16,1,0.3,1) ' + (100 + i * 70) + 'ms';
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          h1.querySelectorAll('.word').forEach(function (w) {
            w.style.opacity = '1';
            w.style.transform = 'translateY(0)';
          });
          h1.classList.add('animate');
        });
      });
    }
  }

  /* ── SF-8: Magnetic buttons ──────────────────────────────────────────── */
  /* Subtle hover pull effect on .btn-magnetic elements. */
  if (!REDUCED && window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.btn-magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * 0.18;
        var dy = (e.clientY - (r.top + r.height / 2)) * 0.22;
        btn.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ── SF-6: Scroll-triggered reveal (.reveal, .edge-card) ─────────────── */
  /* IntersectionObserver adds .in-view class when element enters viewport.
     CSS for .reveal and .reveal.in-view lives in opora-home.css (see below). */
  if ('IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal, .edge-card').forEach(function (el) {
      if (REDUCED) {
        // Skip animation — show immediately
        el.classList.add('in-view');
      } else {
        revealIO.observe(el);
      }
    });
  }

  /* ── SF-9: Counter animations ([data-target]) ────────────────────────── */
  /* Stat numbers count up when scrolled into view.
     Apply data-target="N" (and optionally data-suffix="+") to stat elements.
     The homepage hero stats list already has .ohv3-hero__stats-num spans. */
  function animateCounter(el) {
    var target = parseInt(el.dataset.target, 10);
    if (isNaN(target)) return;
    var suffix = el.dataset.suffix || '';
    var duration = REDUCED ? 0 : 2000;
    if (duration === 0) {
      el.textContent = target.toLocaleString() + suffix;
      return;
    }
    var start = performance.now();
    function easeOutExpo(t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }
    function tick(now) {
      var p = Math.min((now - start) / duration, 1);
      el.textContent = Math.round(target * easeOutExpo(p)).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCounter(e.target);
          counterIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });

    document.querySelectorAll('.counter[data-target]').forEach(function (el) {
      counterIO.observe(el);
    });
  }

})();
